import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import {
  getVendorList,
  getVendorBrandRelationship,
  type GetVendorBrandRelationshipRequestType,
} from 'features/CategoryAndPosisi/services/catalogue'
import { getVendorDetails } from 'features/Enterprise/Vendor/services/addEditVendor'
import { SLICE_NAME_CATALOGUE_ADD_EDIT } from './slice'

export const fetchVendorList = createAsyncThunk(
  `${SLICE_NAME_CATALOGUE_ADD_EDIT}/fetchVendorList`,
  async (search: string) => {
    try {
      const { data } = await getVendorList({
        params: { page_index: 1, page_size: 20, source_type: 'Principal', company_name: search },
      })

      return data?.data || []
    } catch (err) {
      callErrorMsg(err, 'Gagal mendapatkan daftar vendor')

      return []
    }
  },
)

export const fetchBrandList = createAsyncThunk(
  `${SLICE_NAME_CATALOGUE_ADD_EDIT}/fetchBrandList`,
  async (vendorId: string, { rejectWithValue }) => {
    try {
      const { data } = await getVendorDetails(vendorId)

      return data.data
    } catch (err) {
      callErrorMsg(err, 'Gagal mendapatkan daftar brand')

      return rejectWithValue(err)
    }
  },
)

export const fetchMappingVendorBrand = createAsyncThunk(
  `${SLICE_NAME_CATALOGUE_ADD_EDIT}/fetchMappingVendorBrand`,
  async ({ vendorId }: { vendorId: number[] }, { rejectWithValue }) => {
    try {
      return await Promise.all(vendorId.map((id) => getVendorDetails(id.toString())))
    } catch (err) {
      callErrorMsg(err)

      return rejectWithValue(err)
    }
  },
)

export const fetchVendorBrandRelationship = createAsyncThunk(
  `${SLICE_NAME_CATALOGUE_ADD_EDIT}/fetchVendorBrandRelationship`,
  async (
    { vendorId, search, page_size }: { vendorId: number[]; search?: string; page_size?: number },
    { rejectWithValue },
  ) => {
    const params: GetVendorBrandRelationshipRequestType['params'] = {
      vendor_ids: vendorId,
      page_size: 20,
    }
    if (search) {
      params.search = search
    }
    if (page_size) {
      params.page_size = page_size
    }

    try {
      const { data } = await getVendorBrandRelationship({
        params,
      })

      return data.data
    } catch (err) {
      callErrorMsg(err, 'Gagal mendapatkan daftar brand')

      return rejectWithValue(err)
    }
  },
)
